import React from 'react';
import { useAuth } from '../context/shared/AuthContext';
import { useTheme } from '../context/shared/ThemeContext';
import PageSection from '../components/common/PageSection';

const Calendar: React.FC = () => {
  const { user } = useAuth();
  const { themeClasses } = useTheme();

  return (
    <div className="py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className={`text-3xl font-bold ${themeClasses.primaryText}`}>Calendar</h1>
        <p className={`text-xl ${themeClasses.secondaryText}`}>
          View your emotional journey over time
        </p>
      </div>

      <PageSection title="Monthly Overview" emoji="📅">
        <div className={`${themeClasses.cardBg} rounded-lg p-6`}>
          <p className={`text-center ${themeClasses.secondaryText}`}>
            Calendar functionality coming soon! This will show your mood patterns, 
            therapy sessions, and emotional insights over time.
          </p>
        </div>
      </PageSection>
    </div>
  );
};

export default Calendar;
